import { sentryQabConfig } from './sentryConfig';

export const sentryConfigActivationTransferCover = {
  ...sentryQabConfig,
  dsn: 'https://059cdecc4ad21c0fbdac9af41c1ece83@o207017.ingest.sentry.io/4505979831975936',
};
